import { createAction, props } from '@ngrx/store';
import { Alert } from './../../formState/model/alert';

export const FormSaved = createAction(
  '[Shared][Form State] Saved'
);

export const FormReset = createAction(
  '[Shared][Form State] Reset'
);

export const FormSetAlert = createAction(
  '[Shared][FormState] Alert set',
  props<{ alert: Alert }>()
);

export const FormClearAlert = createAction(
  '[Shared][FormState] Alert clear'
);

